import { render, staticRenderFns } from "./printRMB.vue?vue&type=template&id=fee5045c"
import script from "./printRMB.vue?vue&type=script&lang=js"
export * from "./printRMB.vue?vue&type=script&lang=js"
import style0 from "./printRMB.vue?vue&type=style&index=0&id=fee5045c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports